// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title:'Profile',
    path:'/dashboard/profile',
    icon: icon('ic_user'),
  },
  {
    title:'Marketing',
    path:'/dashboard/marketing',
    icon: icon('ic_user'),
  },
   {
    title:'Manager',
    path:'/dashboard/manager',
    icon: icon('ic_user'),
  },
  {
    title: 'Product',
    path: '/dashboard/product',
    icon: icon('ic_user'),
  },
 
];

export default navConfig;
